import { getEmployeeDisplayName } from 'modules/core/lib/employeeName'

export type FullDisplayNameParams = {
  firstName: string | null
  lastName: string | null
  canSharePreferredName?: boolean
  preferredName?: string | null
}

/**
 * Returns the full display name for a user, optionally using preferred name
 * when the caller is allowed to see it (e.g. from employee policy).
 * No User or Employee types; call sites pass plain attributes.
 */
export const getFullDisplayName = ({
  firstName,
  lastName,
  canSharePreferredName = false,
  preferredName,
}: FullDisplayNameParams): string => {
  const first = firstName?.trim() || ''
  const last = lastName?.trim() || ''
  const fullName = [first, last].filter(Boolean).join(' ')
  const displayPreferred =
    canSharePreferredName && preferredName?.trim() ? preferredName.trim() : undefined
  return getEmployeeDisplayName({
    fullName,
    lastName: last,
    preferredName: displayPreferred,
  })
}
